import * as React from "react";


export default class MapObjectFilter extends React.Component {

    constructor () {
        super();
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleInputChange (event, room) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        let newRooms;

        if (value) {
            newRooms = this.props.visibleRooms.slice();
            newRooms.push(room);
        } else {
            newRooms = this.props.visibleRooms.slice().filter(r => {
                return r !== room;
            });
        }
        this.props.roomsChange(newRooms);
    }

    render () {

        //const valid =

        const roomOptions = this.props.objects.data.map(obj => {
            return obj.data['rooms'];
        }).reduce((p, c) => {
            if (c && p.indexOf(c) < 0) {
                p.push(c);
            }
            return p;
        }, []).sort();

        const checkboxes = roomOptions.map(room => {
            const checked = this.props.visibleRooms.indexOf(room) > -1;
            return (
                <label className="checkbox" key={room}>
                    <input type="checkbox" checked={checked}
                           onChange={(evt) => this.handleInputChange(evt, room)}/> {room} ROK
                    <span className="check"></span>
                </label>
            );
        });


        return (<div className="cw-object-map-filter">
            <div className="checkboxes">
                {checkboxes}
            </div>
        </div>)
    }
}



// WEBPACK FOOTER //
// ./src/components/MapObjectFilter.jsx